// extracted by mini-css-extract-plugin
module.exports = {"item":"_c3994e99","link":"_bec4a36c","title":"_7cac324c","image":"_fa3b8bab","cta":"_3c2b37ba","shimmerLoadingBackground":"_4cd82321"};